import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnline } from '../lib/offline';
import { t } from '../lib/i18n';

const OfflineBanner = () => {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="mb-4 flex items-center gap-3 rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-300" role="status" data-testid="offline-banner">
      <WifiOff size={18} className="shrink-0" />
      <span><strong>{t("Vous êtes hors ligne.")}</strong> {t('Vos catalogues récemment ouverts sont toujours disponibles ci-dessous.')}</span>
    </div>
  );
};

export default OfflineBanner;
